<template>
    <div>

        <div class="latest-news">
            <h2 class="generic-title">{{GenericTitle}}</h2>
            <div class="row">
                <div class="col-md-4" v-bind:key="index" v-for="(item, index) in latestGenericDetails">
                    <div class="generic-card news-card" v-bind:class="{ 'announcement-card': isAnnouncements }">
                        <div class="generic-card-link">
                            <div class="card-img">
                                <a :href="item.Url">
                                    <img v-if="IsShowAnnounceImage" :src="item.Image" alt="card image" @error="replaceByDefaultImg" />
                                </a>
                            </div>
                            <div 
                                class="card-content"
                                :class="!IsShowAnnounceImage? 'card-content-announce' : null"
                            >
                                <div class="inner-content">
                                    <span class="card-date published-date" v-show="isNews || isAnnouncements">{{item.PublishedDate}}</span>
                                    <div class="card-date card-events-date" v-show="isEvents">
                                        <span>{{item.DateFrom}}</span>
                                        <span class="date-separator"></span>
                                        <span>{{item.DateTo}}</span>
                                    </div>
                                    <a :href="item.Url">
                                        <h2 class="card-title" v-show="isAnnouncements">{{item.AnnouncementsTitle}}</h2>
                                        <h2 class="card-title" v-show="isNews || isEvents">{{item.Title}}</h2>
                                    </a>
                                    <p class="card-brief">{{item.Brief}} </p>
                                </div>
                                <div class="card-link">
                                    <a :href="item.Url" class="read-more"><span>{{readMore}}</span><i class="icon-next"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';

    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let contactApiUrl;
    let listingThis;

    export default {
        props: {
            parentContentId: {
                type: String
            },
            GenericTitle: {
                type: String
            },
            readMore: {
                type: String
            },
            filter: {
                type: String
            },
            lang: {
                type: String
            },
            API: {
                type: String
            },
            isNews: {
                type: Boolean
            },
            isEvents: {
                type: Boolean
            },
            isAnnouncements: {
                type: Boolean
            },
            IsShowAnnounceImage: {
                type: Boolean
            }
        },
        data() {
            return {
                latestGenericDetails: []
            }
        },
        methods: {
            getData() {
                if (listingThis.isNews) {
                    contactApiUrl = `${apiUrl}/umbraco/surface/${listingThis.API}?culture=${listingThis.lang}&contentId=${listingThis.parentContentId}`;
                } else if (listingThis.isEvents) {
                    contactApiUrl = `${apiUrl}/umbraco/surface/${listingThis.API}?culture=${listingThis.lang}&contentId=${listingThis.parentContentId}`;
                } else if (listingThis.isAnnouncements) {
                    contactApiUrl = `${apiUrl}/umbraco/surface/${listingThis.API}?culture=${listingThis.lang}&contentId=${listingThis.parentContentId}`;
                }

                axios.get(contactApiUrl)
                    .then(function (response) {

                        if (listingThis.isNews) {
                            listingThis.latestGenericDetails = response.data.NewsItems;
                        } else if (listingThis.isEvents) {
                            listingThis.latestGenericDetails = response.data.EventsItems;
                        } else if (listingThis.isAnnouncements) {
                            listingThis.latestGenericDetails = response.data;
                        }
                    })
                    .then(() => {
                        listingThis.replaceEmptySrc();
                    })
            },
            replaceByDefaultImg(e) {
                e.target.src = "../../../../../src/assets/default.png";
            },
            replaceEmptySrc() {
                let cardsImg = document.querySelectorAll('.card-img img');
                cardsImg.forEach((item) => {
                    if (item.getAttribute('src') == null) {
                        item.src = '../../../../../src/assets/default.png';
                    }
                })
            }
        },
        mounted() {
            listingThis = this;
            listingThis.getData();
        }
    }
</script>
